import React, { CSSProperties, ReactNode } from 'react';
import { ActionMap, ProductType, SubsAction } from '../../../redux/types';
import { useTranslation } from '../../../hooks/useTranslation';
import { ProductDetail } from './ProductDetail';

const PricingPanel = ({
  children,
  className,
  style,
}: {
  children: ReactNode; //ReactNode React.Component
  className?: string;
  style: CSSProperties;
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const ProductList = ({ products, loading, doAction }: any) => {
  const t = useTranslation();
  return (
    <PricingPanel
      className="subs-plans"
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'stretch', // take all height for both siblings
      }}
    >
      {products?.map((product: ProductType) => {
        // FIXME improve
        let targetAction: SubsAction = SubsAction.NONE;
        if (product.actions?.includes(SubsAction.ADD_PAYMENT_METHOD)) {
          targetAction = SubsAction.ADD_PAYMENT_METHOD;
        } else if (product.actions?.includes(SubsAction.USER_ACTION_REQUIRED)) {
          targetAction = SubsAction.USER_ACTION_REQUIRED;
        } else if (product.actions?.includes(SubsAction.MANAGE)) {
          targetAction = SubsAction.MANAGE;
        } else if (product.actions?.includes(SubsAction.SUBSCRIBE_TRIAL)) {
          targetAction = SubsAction.SUBSCRIBE_TRIAL;
        } else if (product.actions?.includes(SubsAction.SUBSCRIBE)) {
          targetAction = SubsAction.SUBSCRIBE;
        }

        const onClick = () =>
          doAction(
            product.subscriptionType,
            targetAction,
            product?.pricings?.['MONTHLY']?.pricingId
          );
        const targetText = t(loading ? 'action_loading' : ActionMap[targetAction]);
        const isIncluded =
          (!product.pricings || !Object.keys(product.pricings).length) &&
          !!products.find(
            (s: ProductType) =>
              product.subscriptionType !== s?.subscriptionType && s?.currentSubscription?.active //&& !!s.pricings,
          );

        return (
          <ProductDetail
            loading={loading}
            key={product.subscriptionType}
            isIncluded={isIncluded}
            prodType={product}
            onClick={onClick}
            clickText={targetText}
          />
        );
      })}
    </PricingPanel>
  );
};
